import request from '@/utils/request2'

// 列表(主数据列表)
export function loadUserInsurancePolicyListDataApi(data) {
  return request({
    url: 'tms-web/userInsurancePolicy/listByPage',
    method: 'post',
    data
  })
}

// 导出
export function exportUserInsurancePolicyListDataApi(data) {
  return request({
    url: 'tms-web/userInsurancePolicy/exportByPage',
    method: 'post',
    data
  })
}

// 保存
export function saveUserInsurancePolicyApi(data) {
  return request({
    url: 'tms-web/userInsurancePolicy/save',
    method: 'post',
    data
  })
}

// 作废
export function deleteUserInsurancePolicyApi(data) {
  return request({
    url: 'tms-web/userInsurancePolicy/delete',
    method: 'post',
    data
  })
}

// 查看
export function viewUserInsurancePolicyApi(data) {
  return request({
    url: 'tms-web/userInsurancePolicy/view',
    method: 'post',
    data
  })
}